module.exports = __webpack_public_path__ + "img/logo.9201dd19.png";